export interface SortOption {
  id: string;
  label: string;
}
